<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { useStore } from "./stores/index"

export default defineComponent({
  name: "App",
  setup() {
    // vuex
    const store = useStore()
  }
})
</script>
